export default "__VITE_ASSET__BlfZgtJs__"